import { Amplify } from 'aws-amplify'
import { getCognitoId } from 'components/util/UserId'
import React, { useEffect, useState } from 'react'
import LinkRoute from '../../ui/link/Link'

//@ts-ignore
import awsconfig from '../../../aws-exports'
Amplify.configure(awsconfig)

export interface LinkButtonProp {
  buttonColor: string
  buttonText: string
  loggedInButtonText: string | null
  buttonTextColor: string
  buttonUrl: string
  loggedInButtonUrl?: string
  isLink: boolean
  hasIcon: boolean
  icon: string
  classList?: string
  onClick: Function
  outline: boolean
}

const defaultButtonClasses =
  'inline-block bg-white py-2 px-4 border border-transparent rounded-full text-base font-medium text-indigo-600 hover:bg-indigo-50'

const LinkButton = ({
  buttonUrl,
  buttonColor,
  buttonTextColor,
  buttonText,
  loggedInButtonText = '',
  loggedInButtonUrl = '',
  isLink,
  hasIcon,
  icon,
  classList = defaultButtonClasses,
  onClick = () => {}
}: LinkButtonProp) => {
  const [isSignedIn, setIsSignedIn] = useState(false)

  const dogDetailsPage = 'dog-details'

  const getButtonUrl = () => {
    if (isSignedIn) {
      return loggedInButtonUrl
    } else if (buttonUrl === '/signup/dog-details-1') {
      return `/signup/${dogDetailsPage}`
    }
    return buttonUrl
  }

  useEffect(() => {
    const checkIfSignedIn = async () => {
      const username = await getCognitoId()
      if (username) {
        setIsSignedIn(true)
      } else {
        setIsSignedIn(false)
      }
    }

    document.querySelector('body')?.addEventListener('mouseover', checkIfSignedIn)

    return () => {
      document.querySelector('body')?.removeEventListener('mouseover', checkIfSignedIn)
    }
  }, [])

  if (isLink) {
    return (
      <LinkRoute href={getButtonUrl()} className="text-white" style={{ color: buttonTextColor }} onClick={onClick}>
        {loggedInButtonText && isSignedIn ? loggedInButtonText : buttonText} <span aria-hidden="true">&rarr;</span>
      </LinkRoute>
    )
  }

  return (
    <>
      {hasIcon && (
        <>
          {/* Desktop */}
          <LinkRoute
            href={getButtonUrl()}
            className={`${classList} hidden lg:block`}
            style={{ backgroundColor: buttonColor, color: buttonTextColor }}
            onClick={onClick}
          >
            {icon && <img className="w-8 h-auto" src={icon} alt="icon" />}
          </LinkRoute>
          {/* Mobile */}
          <LinkRoute
            href={getButtonUrl()}
            className={`${classList} block lg:hidden`}
            style={{ backgroundColor: buttonColor, color: buttonTextColor }}
            onClick={onClick}
          >
            {icon && <img className="w-6 h-6 mr-3" src={icon} alt="icon" />}
            {loggedInButtonText && isSignedIn ? loggedInButtonText : buttonText}
          </LinkRoute>
        </>
      )}
      {!hasIcon && (
        <LinkRoute
          href={getButtonUrl()}
          className={`${classList} shadow`}
          style={{ backgroundColor: buttonColor, color: buttonTextColor }}
          onClick={onClick}
        >
          {loggedInButtonText && isSignedIn ? loggedInButtonText : buttonText}
        </LinkRoute>
      )}
    </>
  )
}

export default LinkButton

export const LinkButtonRegisterProps = {
  name: 'buttonProps',
  type: 'object',
  defaultValue: {
    buttonColor: 'white',
    buttonText: 'Click Me',
    buttonTextColor: 'black',
    buttonUrl: '#',
    loggedInButtonUrl: '',
    isLink: false,
    hasIcon: false,
    icon: ''
  },
  subFields: [
    { name: 'buttonColor', type: 'color', defaultValue: 'white' },
    { name: 'buttonText', type: 'string', defaultValue: 'Click Me' },
    { name: 'loggedInButtonText', type: 'string', defaultValue: 'Logged In' },
    { name: 'buttonTextColor', type: 'color', defaultValue: 'black' },
    { name: 'buttonUrl', type: 'text', defaultValue: '#' },
    { name: 'loggedInButtonUrl', type: 'text', defaultValue: '' },
    { name: 'isLink', type: 'boolean', defaultValue: false },
    { name: 'hasIcon', type: 'boolean', defaultValue: false },
    { name: 'icon', type: 'file', defaultValue: null }
  ]
}
